import React, { useRef } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

import useAnimate from '../ui/Motion';

import SectionHead from './SectionHead';
import useMediaQuery from '../ui/useMediaQuery';
import { process as steps, processHeading } from '../data/site';

const EASE = [0.16, 1, 0.3, 1];

/** Three steps on a rail that fills in as the reader scrolls them. */
export default function ProcessRail({
    eyebrow = processHeading.eyebrow,
    title = processHeading.title,
    items = steps
}) {
    const ref = useRef(null);
    const reduced = !useAnimate();
    const horizontal = useMediaQuery('(min-width: 861px)');

    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ['start 0.8', 'end 0.7']
    });

    const draw = useSpring(scrollYProgress, { stiffness: 120, damping: 32, restDelta: 0.001 });
    const lineStyle = reduced
        ? undefined
        : (horizontal ? { scaleX: draw } : { scaleY: draw });

    return (
        <section className="section section--ruled process">
            <div className="shell">
                <SectionHead eyebrow={eyebrow} title={title} />

                <div className="process__grid" ref={ref} style={{ '--steps': items.length }}>
                    <div className="process__rail" aria-hidden="true">
                        <motion.span className="process__rail-fill" style={lineStyle} />
                    </div>

                    {items.map((item, i) => (
                        <motion.article
                            className="process__step"
                            key={item.step}
                            initial={reduced ? false : { opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.4 }}
                            transition={{ duration: 0.85, delay: i * 0.12, ease: EASE }}
                        >
                            <span className="process__node" aria-hidden="true" />
                            <span className="process__num">{item.step}</span>
                            <h3 className="t-h3 process__title">{item.title}</h3>
                            <p className="t-body">{item.body}</p>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
}
